export const globalVariable = {
  baseURL: process.env.REACT_APP_API_URL,
  countryId: 233
}
